import React from 'react';
import { Icon } from './Icon.js';
export const IconMediaPauseFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M2.25 11C1.2835 11 0.5 10.2165 0.5 9.25L0.5 2.75C0.5 1.7835 1.2835 1 2.25 1L3.25 1C4.2165 1 5 1.7835 5 2.75L5 9.25C5 10.2165 4.2165 11 3.25 11H2.25Z", fill: "currentColor" }),
        React.createElement("path", { d: "M7 9.25C7 10.2165 7.7835 11 8.75 11H9.75C10.7165 11 11.5 10.2165 11.5 9.25V2.75C11.5 1.7835 10.7165 1 9.75 1L8.75 1C7.7835 1 7 1.7835 7 2.75L7 9.25Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconMediaPauseFill12.js.map